import React, { useContext, useState } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import Menu from './Menu.jsx';
import Vendors from './Vendors.jsx';
import Orders from './Orders.jsx';
import Drivers from './Drivers.jsx';
import Reports from './Reports.jsx';
import Settings from './Settings.jsx';
import { s } from '../Style.jsx';

const Dispatch = () => {

    const { authorizing, person } = useContext(PersonContext);

    const [screen, setScreen] = useState("Orders");

    return <div>
        {person?.roles && person.roles.includes("dispatch") && <>
            <div style={{ ...s.headerBox, marginBottom: 20 }}>
                <div style={s.headerInnerBox}>
                    <h1 style={{ marginBottom: 0 }}>Dispatch</h1>
                    <Menu setScreen={setScreen} screen={screen} />
                </div>
            </div>
            <div style={s.paddingContainer}>
                <div style={{}}>
                    {screen === "Vendors" && <Vendors />}
                    {screen === "Orders" && <Orders />}
                    {screen === "Drivers" && <Drivers />}
                    {screen === "Reports" && <Reports />}
                    {screen === "Settings" && <Settings />}
                </div>
            </div>
        </>}
    </div>;

}
export default Dispatch;
